<template>
  <div
    class="cursor-pointer max-w-sm w-full hover:opacity-90 duration-300 shadow hover:scale-[1.03] transition-transform rounded-md ring-1 ring-gray-300 p-1"
    @click="$emit('click')"
  >
    <div class="relative rounded-lg overflow-hidden aspect-video">
      <img
        :src="image ?? banner"
        alt="Capa da notícia"
        class="w-full h-full object-cover"
      />
      <span
        v-if="duration"
        class="absolute bottom-1 right-1 bg-black bg-opacity-80 text-white text-xs font-semibold px-1.5 py-0.5 rounded"
      >
        {{ duration }}
      </span>
    </div>

    <div class="flex mt-3 gap-3 h-[100px]">
      <div
        v-if="channelLogo"
        class="flex-shrink-0 w-9 h-9 rounded-full overflow-hidden ring-1 ring-white my-auto"
      >
        <img
          :src="channelLogo"
          alt="Logo canal"
          class="w-full h-full object-cover"
        />
      </div>

      <div class="flex flex-col w-full text-start tracking-wide">
        <h3 class="text-2xl font-semibold text-white leading-snug line-clamp-2 my-auto">
          {{
            title.length > 40
            ? title.slice(0, 40).concat('...')
            : title
          }}
        </h3>
        <div class="mt-auto bottom-0">
          <p class="text-xs text-gray-400 mt-1">
            • {{ category }}
          </p>
          <p class="text-xs text-gray-500">{{ views }} • {{ publishedAt }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { dataShared } from '@/shared/store'
import { computed } from 'vue'

const props = defineProps({
  image: String,
  title: String,
  category: String,
  channelLogo: String,
  views: String,
  publishedAt: String,
  duration: String // opcional
})

const banner = computed(() => dataShared.getters.getAppLogo)

</script>

<style scoped lang="scss">
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
